import { doc, getDoc, setDoc } from 'firebase/firestore'
import { db } from '../firebase'
import { DEFAULT_CONTENT } from '../config/contentSchema'

const CONTENT_COLLECTION = 'content'

export class ContentService {
  static async getContent(page = 'all') {
    try {
      const docRef = doc(db, CONTENT_COLLECTION, 'main')
      const docSnap = await getDoc(docRef)

      if (docSnap.exists()) {
        const data = docSnap.data()
        return page === 'all' ? data : data[page]
      }

      // Return default content if no data exists
      return page === 'all' ? DEFAULT_CONTENT : DEFAULT_CONTENT[page]
    } catch (error) {
      console.error('Error fetching content:', error)
      return page === 'all' ? DEFAULT_CONTENT : DEFAULT_CONTENT[page]
    }
  }

  static async getHeroSlides(options = {}) {
    const { limit } = options || {}

    try {
      const homeContent = await this.getContent('home')
      const slides =
        (homeContent && Array.isArray(homeContent?.hero?.slides)
          ? homeContent.hero.slides
          : []) || []

      if (typeof limit === 'number' && limit >= 0) {
        return slides.slice(0, limit)
      }

      return slides
    } catch (error) {
      console.error('Error fetching hero slides:', error)
      return []
    }
  }

  static async updateContent(page, content) {
    try {
      const docRef = doc(db, CONTENT_COLLECTION, 'main')
      await setDoc(docRef, { [page]: content }, { merge: true })
      return true
    } catch (error) {
      console.error('Error updating content:', error)
      return false
    }
  }

  static async updateAllContent(content) {
    try {
      const docRef = doc(db, CONTENT_COLLECTION, 'main')
      await setDoc(docRef, content)
      return true
    } catch (error) {
      console.error('Error updating all content:', error)
      return false
    }
  }

  static async initializeContent() {
    try {
      const docRef = doc(db, CONTENT_COLLECTION, 'main')
      const docSnap = await getDoc(docRef)

      if (!docSnap.exists()) {
        await setDoc(docRef, DEFAULT_CONTENT)
        console.log('Content initialized with default values')
        return true
      }
      return false
    } catch (error) {
      console.error('Error initializing content:', error)
      return false
    }
  }
}
